import { IIdsRequest } from "../../model/request/IIdsRequest";
import { IMonHoc } from "../../model/respone/category/IMonHoc";
import { apiClient } from "../apiClient";
export const MON_HOC_API = "mon-hoc";
export const monHocApi = {
  SelectAll: () => apiClient.get(`${MON_HOC_API}`),
  Insert: (payload: IMonHoc) => apiClient.post(`${MON_HOC_API}`, payload),
  Update: (payload: IMonHoc) => apiClient.put(`${MON_HOC_API}`, payload),
  Updates: (payload: IMonHoc[]) => apiClient.put(`${MON_HOC_API}/updates`, payload),
  Delete: (id: number) => apiClient.delete(`${MON_HOC_API}/${id}`),
  Deletes: (rq: IIdsRequest) => apiClient.put(`${MON_HOC_API}/deletes`, rq),
  ReadAndValidateImportData: (payload: any) => apiClient.post(`${MON_HOC_API}/import/read-and-validate`, payload),
  Import: (payload: any) => apiClient.post(`${MON_HOC_API}/import`, payload),
};
